import React, { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faTrash } from '@fortawesome/free-solid-svg-icons';
import Loader from 'Flow2/components/AdvancedBox/AdvancedUI/Loader/Loader';
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import './DropDownWithInput.scss';

function DropdownWithInput(props) {
    const [current, setCurrent] = useState({});
    const [data, setData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [ddInput, setDDInput] = useState('');
    const [showAll, setShowAll] = useState(false);
    let loading = false;

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const setInitData = () => {
        setDDInput('');
        setIsOpen(false);
    }

    const onDDItemClick = (item) => {
        props.onDDClick(item);
        setTimeout(() => {
            setCurrent(item);
            setInitData();
        }, 100);
    }

    const onDDItemTrashClick = (item) => {
        props.onDDTrashClick(item);
    }

    const handleInputChange = (e) => {
        const { value } = e.target;
        setDDInput(value);
        if (value && value.length > 1) {
            let newData = props.data.filter(item => item.intl.toLowerCase().includes(value.toLowerCase()))
            setData(newData);
        }

    }

    const handleOutside = ({ target }) => {
        if (!target.closest('.dropdowninput-box')) {
            setInitData();
        }
    }


    const onShowAllClick = () => {
        loading = true;
        if (showAll) {
            setShowAll(false);
            setNewData({ isAll: false });
        }
        else {
            setShowAll(true);
            setNewData({ isAll: true });
        }
        // setIsOpen(true);
        setTimeout(() => {
            loading = false;
        }, 1000);
    }

    const setNewData = ({ isAll = false }) => {
        let newData = props.data;
        if (props.showMax && !isAll) newData = newData.slice(0, props.showMax);
        setData(newData);
    }

    useEffect(() => {
        window.addEventListener('click', handleOutside);
        return () => {
            window.removeEventListener('click', handleOutside)
        }
    }, []);

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setNewData({});
            if (props.current) {
                if (typeof props.current == 'string') {
                    let found = props.data.find(item => item.value === props.current
                        || item.name === props.current);
                    if (found) setCurrent(found);
                } else {
                    setCurrent(props.current);
                }
            }
            else setCurrent(props.data[0]);
        }
    }, [props.data, props.current])

    return (
        <div className="dropdowninput-box">
            <input type="text" className="dropdown-top-input" value={ddInput}
                onBlur={() => setIsOpen(false)} onFocus={() => setIsOpen(true)}
                onChange={handleInputChange} />
            <div
                className={isOpen ? "dropdown active" : "dropdown"}
                onClick={() => {
                    if (data && data.length > 0 && !loading) setIsOpen(!isOpen)
                }}>
                <div className="dropdown-top">
                    <div>{(current && current.intl) ? fm({ id: current.intl }) : current.value}</div>
                    <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
                </div>
                <CSSTransition in={isOpen} timeout={300} classNames="dropdown-animation"
                    unmountOnExit onEnter={() => setIsOpen(true)} onExited={() => setIsOpen(false)}>
                    <div className="dropdown-box">
                        <ul>
                            {data && data.map((item, i) => (
                                <li className="dropdown-li" key={`dropdownMenuItem${i}`}>
                                    <a className="data-link" onClick={onDDItemClick.bind(null, item)}>
                                        {item.intl ? fm({ id: item.intl }) : item.value}
                                    </a>
                                    {(props.isDeleted && item.value !== aTypes.DUMMY_X) && (
                                        <span onClick={onDDItemTrashClick.bind(null, item)}
                                            className="dropdown-icon">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </span>
                                    )}
                                </li>
                            ))}
                            {props.showMax && (
                                <div className="dropdown-showall" onClick={onShowAllClick}>
                                    <span> {fm({ id: showAll ? 'advanced.showDDLess' : 'advanced.showDDAll' })}</span>
                                    {(!showAll && loading) && <Loader />}
                                </div>
                            )}
                        </ul>
                    </div>
                </CSSTransition>
            </div>
        </div>
    )
}

export default injectIntl(DropdownWithInput);
